import { OnboardingWizard } from "@/components/onboarding/OnboardingWizard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/onboarding")({
  component: OnboardingWizard,
});
